import * as React from 'react';
import * as styles from './style.css';
import { Tooltip, UIHeading1, UIText1 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { VerticalSlider } from '../VerticalSlider';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

interface IAwardsWrapperProps {
  title: string;
  sourceLabel: string;
  sourceTooltip: React.ReactNode;
  id: string;
  onShow: () => void;
}

export const AwardsWrapper = ({
  id,
  children,
  title,
  sourceLabel,
  sourceTooltip,
  onShow,
}: React.PropsWithChildren<IAwardsWrapperProps>) => {
  return (
    <section className={styles['wrapper']} id={id}>
      <div className={styles['title']}>
        <ActionAfterViewObserver callback={onShow} triggerOnce>
          <UIHeading1 as="h2">{title}</UIHeading1>
        </ActionAfterViewObserver>
        <div className={styles['source']}>
          <UIText1 display="inline">{sourceLabel}</UIText1>
          <Tooltip title={sourceTooltip} theme="white">
            <div className={styles['description-icon']}>
              <IconFunctionalInformationCircle16 />
            </div>
          </Tooltip>
        </div>
      </div>
      <div className={styles['slider']}>
        <VerticalSlider arrow={() => null} containerClass={styles['slider-list']}>
          {children}
        </VerticalSlider>
      </div>
    </section>
  );
};
